export const ADD_RENT_GUARANTEE_FEE = 'addRentGuaranteeFee';
export const SUBTRACT_RENT_GUARANTEE_FEE = 'subtractRentGuaranteeFee';
